import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './configureStore';
import App from './app/App';
import { configureAmplify } from './app/configureAmplify';
import { SessionProvider } from './context/SessionProvider';
import { ThemeProvider } from './context/ThemeProvider';
import { APP_BASENAME } from './lib/appUrl';
import './tailwind.css';

configureAmplify();

// Redirect bare root to /app so BrowserRouter's basename matches. Keep the query and hash:
// invitation emails link to <domain>?invid=<id>.
if (window.location.pathname === '/') {
  window.location.replace(APP_BASENAME + window.location.search + window.location.hash);
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <ThemeProvider>
    <Provider store={store}>
      <BrowserRouter basename={APP_BASENAME}>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </Provider>
  </ThemeProvider>,
);
